module.exports = __webpack_public_path__ + "img/sword.55067f03.png";